module.exports = __webpack_public_path__ + "img/icon_order_finish.4ffe3635.png";